import Vue from 'vue'
import Router from 'vue-router'

import { store } from '../../store/store'

// Containers
const LoginContainer = () => import('@/containers/LoginContainer')
const DefaultContainer = () => import('@/containers/DefaultContainer')

// Views
const Login = () => import('@/views/Login')
const Dashboard = () => import('@/views/Dashboard')

// Views - Advertisements / Publcitygroups
const AdvertisementApprovallist = () => import('@/views/advertisements/Advertisements')
const AdvertisementNew = () => import('@/views/advertisements/AdvertisementNew')
const AdvertisementPlanner = () => import('@/views/advertisements/AdvertisementPlanner')
const AdvertisementEditPlanner = () => import('@/views/advertisements/EditPlanner')

// Views - Monitors / Facilities
const FacilityOverview = () => import('@/views/monitors/facilities/Facilities')
// const FacilityDetails = () => import('@/views/monitors/facilities/FacilityDetails')

// Views - Monitors / Publcitygroups
const PublicitygroupOverview = () => import('@/views/monitors/publicitygroups/Groups')
const PublicitygroupAssignment = () => import('@/views/monitors/publicitygroups/GroupAssignment')

// Views - Error
const Page403 = () => import('@/views/Page403')

// Views - Support
const Support = () => import('@/views/Support')

Vue.use(Router)

export default new Router({
	mode: 'hash', // https://router.vuejs.org/api/#mode
	linkActiveClass: 'open active',
	scrollBehavior: () => ({ y: 0 }),
	routes: [
		{
			path: '/',
			redirect: '/login',
			component: LoginContainer,
			children: [
				{
					path: 'login',
					name: 'Login',
					component: Login
				}
			]
		},
		{
			path: '/pc',
			redirect: '/dashboard',
			component: DefaultContainer,
			children: [
				{
					path: 'dashboard',
					name: 'Home',
					component: Dashboard,
					beforeEnter: (to, from, next) => {
						if (!store.getters.isLoggedIn) {
							if (!store.getters.isLoggedIn) {
								store.state.loginStatus = 'error'
								next({ name: 'Login', params: { consecutiveVisit: true } })
							} else {
								next()
							}
						} else {
							next()
						}
					}
				},
				{
					path: 'advertisements',
					redirect: '/pc/advertisements/approvallist',
					name: 'Werbung',
					component: {
						render(c) { return c('router-view') }
					},
					children: [
						{
							path: 'approvallist',
							name: 'Werbung-Freigabeliste',
							component: AdvertisementApprovallist,
							beforeEnter: (to, from, next) => {
								if (!store.getters.isLoggedIn) {
									store.state.loginStatus = 'error'
									next({ name: 'Login', params: { consecutiveVisit: true } })
								} else {
									next()
								}
							}
						},
						{
							path: 'new',
							name: 'Werbung-Neu',
							component: AdvertisementNew,
							beforeEnter: (to, from, next) => {
								if (!store.getters.isLoggedIn) {
									if (!store.getters.isLoggedIn) {
										store.state.loginStatus = 'error'
										next({ name: 'Login', params: { consecutiveVisit: true } })
									} else {
										next()
									}
								} else {
									next()
								}
							}
						},
						{
							path: 'planner',
							name: 'Werbung-Planer',
							component: AdvertisementPlanner,
							beforeEnter: (to, from, next) => {
								if (!store.getters.isLoggedIn) {
									if (!store.getters.isLoggedIn) {
										store.state.loginStatus = 'error'
										next({ name: 'Login', params: { consecutiveVisit: true } })
									} else {
										next()
									}
								} else {
									next()
								}
							}
						},
						{
							path: 'planneredit',
							name: 'Werbung-Planer-Bearbeiten',
							component: AdvertisementEditPlanner,
							beforeEnter: (to, from, next) => {
								if (!store.getters.isLoggedIn) {
									store.state.loginStatus = 'error'
									next({ name: 'Login', params: { consecutiveVisit: true } })
								} else {
									next()
								}
							}
						},
					]
				},
				{
					path: 'monitors',
					redirect: '/pc/monitors/overview',
					name: 'Monitore',
					component: {
						render(c) { return c('router-view') }
					},
					children: [
						{
							path: 'overview',
							name: 'Übersicht',
							component: FacilityOverview,
							beforeEnter: (to, from, next) => {
								if (!store.getters.isLoggedIn) {
									store.state.loginStatus = 'error'
									next({ name: 'Login', params: { consecutiveVisit: true } })
								} else {
									next()
								}
							}
						},
						{
							path: 'groups',
							name: 'Gruppen',
							component: PublicitygroupOverview,
							beforeEnter: (to, from, next) => {
								if (!store.getters.isLoggedIn) {
									if (!store.getters.isLoggedIn) {
										store.state.loginStatus = 'error'
										next({ name: 'Login', params: { consecutiveVisit: true } })
									} else {
										next()
									}
								} else {
									next()
								}
							}
						},
						{
							path: 'groupassignment',
							name: 'Gruppen-Zuweisung',
							component: PublicitygroupAssignment,
							beforeEnter: (to, from, next) => {
								if (!store.getters.isLoggedIn) {
									if (!store.getters.isLoggedIn) {
										store.state.loginStatus = 'error'
										next({ name: 'Login', params: { consecutiveVisit: true } })
									} else {
										next()
									}
								} else {
									next()
								}
							}
						},
					]
				},
				{
					path: 'error',
					redirect: '/pc/error/forbidden',
					name: 'Fehler',
					component: {
						render(c) { return c('router-view') }
					},
					children: [
						{
							path: 'forbidden',
							name: 'Verboten',
							component: Page403,
							beforeEnter: (to, from, next) => {
								if (!store.getters.isLoggedIn) {
									if (!store.getters.isLoggedIn) {
										store.state.loginStatus = 'error'
										next({ name: 'Login' })
									} else {
										next()
									}
								} else {
									next()
								}
							}
						}
					]
				},
				{
					path: 'support',
					redirect: '/pc/support/mail',
					component: {
						render(c) { return c('router-view') }
					},
					children: [
						{
							path: 'mail',
							name: 'Support',
							component: Support,
							beforeEnter: (to, from, next) => {
								if (!store.getters.isLoggedIn) {
									if (!store.getters.isLoggedIn) {
										store.state.loginStatus = 'error'
										next({ name: 'Login' })
									} else {
										next()
									}
								} else {
									next()
								}
							}
						}
					]
				}
			]
		},

	]
})
